module.exports = __webpack_public_path__ + "img/base.2620c3ed.png";